import { Moment } from 'moment';
import {
  CriteriosRemuneracao,
  ConvencaoJurosFixo,
  IndexadorAtualizacaoMonetaria,
  TipoProjecao,
  PeriodicidadeCorrecao,
  IndexadorRemuneracao,
  DefasagemFixingBase,
  Remuneracao,
  DefasagemFixingDiario,
  DefasagemFixingAnual,
  DefasagemFixingMensal,
  TipoProRata,
  InvestidorPrivado,
  CustoEmissao,
  Custodiante,
} from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { multaMoraFieldsInitialState } from 'common/interfaces/MultaMoraFields';

export const indicePreco: { [key: string]: boolean } = {
  [IndexadorAtualizacaoMonetaria.IGPM]: true,
  [IndexadorAtualizacaoMonetaria.IPCA]: true,
  [IndexadorAtualizacaoMonetaria.USD]: false,
};

export const criteriosRemuneracaoInitialState: CriteriosRemuneracao = {
  moedaEmissao: '',
  remuneracao: {},
  custodiantes: [],
  custoEmissao: {
    feeLaqusBruto: 0
  },
  tipoPagamento: '',
  convencaoCalendarioPagamento: '',
  periodicidadeAmortizacao: '',
  primeiraParcelaAmortizacao: null,
  periodicidadeJuros: '',
  primeiraParcelaJuros: null,
  ...multaMoraFieldsInitialState,
};

export interface Field {
  name: keyof Omit<CriteriosRemuneracao, 'remuneracao'>;
  value: undefined | null | string | number | Moment | Array<Custodiante>;
}

export interface RemuneracaoField {
  name: keyof Remuneracao;
  value:
    | IndexadorRemuneracao
    | DefasagemFixingBase
    | DefasagemFixingDiario
    | DefasagemFixingMensal
    | DefasagemFixingAnual
    | number
    | PeriodicidadeCorrecao
    | TipoProRata
    | boolean
    | TipoProjecao
    | ConvencaoJurosFixo
    | undefined
    | null;
}

export interface CustoEmissaoField {
  name: keyof CustoEmissao;
  value: undefined | null  | number;
}

export const updateField = (field: Field) => {
  return typedAction('cdca/criteriosRemuneracao/UPDATEFIELD', field);
};

export const updateRemuneracao = (value: Remuneracao) => {
  return typedAction('cdca/criteriosRemuneracao/remuneracao/UPDATE', value);
};

export const updateRemuneracaoField = (field: RemuneracaoField) => {
  return typedAction('cdca/criteriosRemuneracao/remuneracao/UPDATEFIELD', field);
};

export const resetCriteriosRemuneracao = () => {
  return typedAction('cdca/criteriosRemuneracao/RESET');
};

export const updateCriteriosRemuneracao = (state: CriteriosRemuneracao) => {
  return typedAction('cdca/criteriosRemuneracao/UPDATE', state);
};

export const updateCustoEmissaoField = (field: CustoEmissaoField) => {
  return typedAction('cdca/criteriosRemuneracao/custoEmissao/UPDATEFIELD', field);
};

export type CriteriosRemuneracaoAction = ReturnType<
  | typeof updateField
  | typeof updateRemuneracao
  | typeof updateRemuneracaoField
  | typeof resetCriteriosRemuneracao
  | typeof updateCriteriosRemuneracao
  | typeof updateCustoEmissaoField
>;
